import { useLocalSearchParams } from 'expo-router';
import EventDetailSchedules from '@/screens/EventDetailSchedules';

export default function PrivateTabsOrganizationScheduleScheduleAEventIdSchedulesRoute() {
  const { eventId } = useLocalSearchParams<{ eventId: string }>();

  return (
    <EventDetailSchedules
      basePath="/organization/schedule/(scheduleB)/[eventId]"
      eventId={eventId}
    />
  );
}
